import { Component, Inject } from '@angular/core';

import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';

import { EntidadeDataService } from 'src/app/core/services/entidade-crud.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { Entidade } from 'src/app/model/entidade/entidade';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    standalone: false
})
export class HomeComponent {

  public entidade: Entidade;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private securityService: SecurityService, private dataService: EntidadeDataService,
    private authService: MsalService, private msalBroadcastService: MsalBroadcastService) {

    const userInfo = securityService.GetUserInfo();
    const entidadeId = userInfo.entityId;

    if (entidadeId) {
      dataService
        .get(entidadeId)
        .subscribe((respose: Entidade) => {
          this.entidade = respose;
        });
    }
  }

  logout() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      this.authService.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/"
      });
    } else {
      this.authService.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    }
  }
}
